<template>
	<div class="row items-center" style="height: 80vh">
		<div class="col-12">
			<q-card>
				<q-card-section>
					<vue-plyr
						ref="plyr"
						:options="{ listeners: { seek: activity.user_watch ? '' : seekAudio } }"
						class="audio"
					>
						<audio playsinline ref="player">
							<source
								:src="`${getResource}#t=${activity.current_time}`"
								:type="$mime.lookup(getMime)"
							/>
						</audio>
					</vue-plyr>
				</q-card-section>
			</q-card>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'AudioPlayer',

	props: ['activity'],

	data() {
		return {
			changed_time: false,
			current_time: 0,
			id_course: '',
			id_trail: '',
			interval: null,
			total_time: null,
		}
	},

	computed: {
		...mapGetters({
			activities: 'activities/activities',
			hierarchy_order: 'activities/hierarchy_order',
			id: 'activities/id',
			offline_activities: 'offline_course/activities',
		}),

		getResource() {
			let offline_activity = this.offline_activities.find(
				(e) => e.item_id === this.activity.item_id
			)
			if (offline_activity) {
				return offline_activity.src
			} else if (this.activity.resource) return this.activity.resource
			else return ''
		},

		player() {
			return this.$refs.plyr.player
		},

		getMime() {
			let offline_activity = this.offline_activities.find(
				(e) => e.item_id === this.activity.item_id
			)
			if (offline_activity) {
				return offline_activity.src
			} else if (this.activity.resource) return this.activity.resource.split('?')[0]
			else return ''
		},
	},

	methods: {
		sendPosition() {
			if (
				this.$isInvalidNumericString(this.current_time) ||
				this.$isInvalidNumericString(this.total_time)
			)
				return

			if (this.current_time != 0 && this.current_time != '') {
				let fd = new FormData()
				fd.append('current_time', this.current_time)
				fd.append('total_time', this.total_time)
				fd.append('id_group_training_module', this.activity.type_id)

				let url = ''
				if (this.id_trail === '')
					url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
				else
					url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`

				this.$axios
					.post(url, fd)
					.then((response) => {
						this.updatePosition()
					})
					.catch((e) => {
						console.log(e)
					})
			}
		},

		updatePosition() {
			let activities = JSON.parse(JSON.stringify(this.activities))
			let obj = activities.find((obj) => {
				return obj.hierarchy_order === this.hierarchy_order
			})
			if (obj) {
				obj.current_time = this.current_time
				this.$store.dispatch('activities/SET_ACTIVITIES', [activities])
			}
		},

		playAudio() {
			if (!this.changed_time) {
				this.player.currentTime = this.activity.current_time
				this.changed_time = true
			}

			this.interval = setInterval(() => {
				this.sendPosition()
			}, 15000)
		},

		pauseAudio() {
			this.sendPosition()
			clearInterval(this.interval)
		},

		endedAudio() {
			this.sendPosition()
			clearInterval(this.interval)
			this.player.stop()
			if (!this.activity.user_watch) {
				setTimeout(() => {
					this.$store.dispatch('activities/SET_ACTIVITY_DATA', [
						this.activity,
						{ user_watch: true },
					])
					this.$emit('finish')
				}, 500)
			}
		},

		audioTimeUpdated(val) {
			this.current_time = val.detail.plyr.currentTime
		},

		metaData(val) {
			this.total_time = val.detail.plyr.media.duration
		},

		seekAudio(e) {},
	},

	mounted() {
		this.player.on('timeupdate', (val) => this.audioTimeUpdated(val))
		this.player.on('loadedmetadata', (val) => this.metaData(val))
		this.player.on('play', (val) => this.playAudio())
		this.player.on('pause', (val) => this.pauseAudio())
		this.player.on('ended', (val) => this.endedAudio())
		if (this.$q.platform.is.mobile) document.querySelector('.plyr__volume').style.display = 'none'
	},

	created() {
		if (this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
		if (this.$route.params.id) this.id_course = this.$route.params.id
	},

	beforeDestroy() {
		this.sendPosition()
		clearInterval(this.interval)
	},
}
</script>

<style scoped></style>
